import { CREATE_AGREEMENT, SEARCH_AGREEMENTS, FETCH_ALL_AGREEMENT, DELETE_AGREEMENT,ADD_INSTALLMENT_TO_AGREEMENT } from "../actions/types";
import _ from 'lodash';
const INITIAL_STATE = {data: {},paginate:{}}

export default (state=INITIAL_STATE, action) => {
    switch (action.type) {
        case CREATE_AGREEMENT:
            return { ...state ,data: { ...state.data, [action.payload.id]:action.payload  }}
        case FETCH_ALL_AGREEMENT:
            const paginate = _.omit(action.payload, 'data');
            return {...state, data:_.mapKeys(action.payload.data, 'id'), paginate}
        case SEARCH_AGREEMENTS:
            return {...state, data:_.mapKeys(action.payload.data, 'id')}
        case DELETE_AGREEMENT:
            return {...state, data:_.omit(state.data, action.payload)};
        case ADD_INSTALLMENT_TO_AGREEMENT:
            return { ...state , data:{ ...state.data, [action.payload.id]:action.payload } }
        default:
            return state;
    }
}